import { ContentModal } from 'sma.common/components/modals';

import React from 'react';
import ReactDOM from 'react-dom';

import Piper from './piper';

const ajax = require('sma.common/ajax');

class PipingModal extends Backbone.View {
	initialize(options) {
		this.context = options.context || null;
		if (typeof this.context === 'string') {
			this.context = [this.context];
		}
		this.froala = options.froala || null;
		this.$textField = options.$textField || null;
		this.fromModal = options.fromModal || false;
		this.updateQueue = this.updateQueue.bind(this);

		this.createModal();
	}

	createModal() {
		const modalContent = '<div id="sma-js-piping-container"></div>';

		this.modal = new ContentModal(
			modalContent, {
				destroyOnClose: true,
				size: 'md',
				title: gettext('Add piping'),
				fromModal: this.fromModal,
				buttons: [{
					label: gettext('Cancel'),
					cls: 'btn btn-link btn-loud',
					handler: (modal) => {
						modal.hide();
					},
				}, {
					label: gettext('Add'),
					cls: 'btn btn-primary btn-loud',
					handler: (modal) => {
						this.submitQueue();
						modal.hide();
					},
				}],
			},
		);

		this.setElement(this.modal.modalWindow);
		this.loadData();
	}

	submitQueue() {
		const delimSelectElement = document.getElementById('sma-js-pipes-delim-selector');
		const delim = delimSelectElement ? delimSelectElement.value : null;

		if (this.froala) {
			this.froala.insertText(this.queue.map((variable) => {
				let { value } = variable;

				if (variable.isMulti && delim) {
					value = `${value}__${delim}`;
				}

				return {
					label: variable.label,
					group: variable.group,
					value,
				};
			}), this.$textField);
		} else {
			const existingContent = this.$textField.val();
			const tags = this.queue.map((variable) => {
				let { value } = variable;

				if (variable.isMulti && delim) {
					value = `${value}__${delim}`;
				}

				return `{{ ${value} }}`;
			}).join(' ');

			this.$textField.val(existingContent + tags);
		}
	}

	loadData() {
		ajax.get({
			url: reverse('pipes-index'),
			data: {
				context: this.context,
			},
			callback: (data) => {
				this.injectReact(data.result);
			},
		});
	}

	updateQueue(newQueue) {
		this.queue = newQueue;
	}

	injectReact(data) {
		ReactDOM.render(
			<Piper
				data={ data }
				updateQueue={ this.updateQueue }
			/>,
			document.getElementById('sma-js-piping-container'),
		);

		this.modal.show();
	}
}


// activate all piping text fields
$(function () {
	$('.sma-js-piping-text-button').each((i, item) => {
		const $pipingButton = $(item);

		var contextString = $pipingButton.attr('data-context');

		if (contextString) {
			var context = contextString.split(' ');
		} else {
			var context = null;
		}

		$pipingButton.on('click', function() {
			this.modal = new PipingModal({
				context: context,
				$textField: $pipingButton.parent().find('input')
			});
		});
	});

});

module.exports = PipingModal;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/pipes.js